import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Function that takes an observable and handles any errors occurring in the callback,
 * continuing where the observable left off.
 *
 * Used when you want to handle an error yet still want the observable to live.
 *
 * @param observable example: services request.
 * @param callback that takes an error. Use to catch network errors.
 */
export const catchAndContinue = <T>(
  observable: Observable<T>,
  callback?: (error: unknown) => void
): Observable<T> =>
  observable.pipe(
    catchError((error: unknown) => {
      callback?.(error);

      return EMPTY;
    })
  );
